import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { useTeamUpdate } from '../../../../hooks';
import { Team } from '../../../../utils/backend-api/teams';
import { Button } from '../../../BaseUI';
import { TextField } from '../../../FormFields';
import FormErrors from '../../../shared/FormErrors';

const EMAIL_DOMAIN_REGEX = /^((?:https?:\/\/)?[^./]+(?:\.[^./]+)+(?:\/.*)?)$/;

const validationSchema = () =>
  Yup.object({
    email_domain: Yup.string()
      .matches(EMAIL_DOMAIN_REGEX, 'Please enter a valid domain')
      .nullable(),
  });

export default function EmailDomainForm({ team }: { team: Team }) {
  const { updateTeamAsync, updateTeamData } = useTeamUpdate();

  const initialValues = {
    email_domain: team?.email_domain?.replace('@', '0') || '',
  };

  return (
    <div data-test="team-settings-domain">
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) =>
          updateTeamAsync({
            email_domain: values.email_domain,
          })
        }
        validationSchema={validationSchema}
        enableReinitialize={true}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <TextField
              name="email_domain"
              label="Corporate Domain"
              placeholder="Enter a corporate domain (e.g. example.com)"
              labelDescription="Allow anyone on my team that signs in with their corporate email to subscribe to The
              Information on my account."
            />
            {!!updateTeamData?.errors && <FormErrors errors={updateTeamData.errors} />}
            <Button
              variant="primary"
              className="mt2"
              type="submit"
              disabled={(!isValid && dirty) || isSubmitting}
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
